import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FaHome, FaUserTie, FaCog, FaRoute, FaExclamationTriangle
} from 'react-icons/fa';
import './Sidebar.css';

const NavItem = ({ to, icon: Icon, label }) => {
  const { pathname } = useLocation();
  const active = pathname === to;
  return (
    <li>
      <Link to={to} className={active ? 'active' : ''}>
        <Icon aria-hidden="true" />
        <span>{label}</span>
      </Link>
    </li>
  );
};

export default function Sidebar() {
  return (
    <aside className="sidebar">
      <h2 className="sidebar-logo">Norro Admin</h2>

      <nav>
        <ul>
          <NavItem to="/active_rides" icon={FaRoute} label="Active Rides" />
          <NavItem to="/" icon={FaHome} label="Home" />
          <NavItem to="/valets" icon={FaUserTie} label="Valets" />
          <NavItem to="/damages" icon={FaExclamationTriangle} label="Damages" />
          <NavItem to="/settings" icon={FaCog} label="Settings" />
        </ul>
      </nav>
    </aside>
  );
}
